import { Cookies } from 'react-cookie';

import { TechnicianSiteFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface addTechnicianToObjectObj {
  objectSlug?: string;
  technician: TechnicianSiteFormValues;
}

export const addTechnicianToObject = async (info: addTechnicianToObjectObj) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const data = await axiosInterceptor.post(
    `objects/${info.objectSlug}/techs/`,
    {
      ...info.technician,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
